import React from 'react';
import MUISnackbar from '@mui/material/Snackbar';
import { useTheme } from '@emotion/react';

import DataModel from '@/shared/utils/redux/data';
import Helper from '@/shared/utils/redux/helper';

const Snackbar = () => {
  const mountedRef = React.useRef(false);
  // STATE
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  // CUSTOM HOOKS
  const {
    successMessage: { snackbar },
  } = DataModel();
  const { setSuccessMessage } = Helper();
  const theme = useTheme();
  const { cactus, common } = theme.palette;

  React.useEffect(() => {
    if (snackbar && snackbar !== '') {
      setOpenSnackbar(true);
    }
  }, [snackbar]);

  React.useEffect(() => {
    if (!openSnackbar && mountedRef.current) {
      // [NOTE]: TIMEOUT 200ms TO MATCH THE TIMING BETWEEN RESET MESSAGE AND SNACKBAR DISAPPEAR ANIMATION
      setTimeout(() => {
        setSuccessMessage({
          snackbar: null,
        });
      }, 200);
    }
    mountedRef.current = true;
  }, [openSnackbar]);

  return (
    <MUISnackbar
      open={openSnackbar}
      autoHideDuration={3000}
      onClose={() => setOpenSnackbar(false)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      message={snackbar}
      ContentProps={{
        sx: {
          backgroundColor: cactus.main,
          color: common.white,
        },
      }}
    />
  );
};

export default Snackbar;
